/**
 * Wygląd pojedynczej notatki
 * 
 * W zależności od ustawień użytkownika wyświetla się prosta notatka lub z formatowaniem
 * 
 */

import React, { useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { convertToRaw, EditorState, ContentState, convertFromHTML, convertFromRaw } from 'draft-js';

import { saveNote, newNote, saveStats } from '../../redux/actions';
import DraftToolbar from './DraftToolbar';
import TitleBar from './TitleBar';
import useStyles from './Note.styles';
import SimpleEditor from './SimpleEditor';
import DraftEditor from './DraftEditor';
import decorator from './DraftEditorDecorator';

function nlToBr(str) {
  return str.replace(/(?:\r\n|\r|\n)/g, '<br>');
}

const defaultTitle = 'Nowa notatka';
const maxTitleSize = 40;
let prevState = { title: '', content: '' };

function getContent(note, decorator) {
  const content = note.content;
  if (content) {
    let state;
    try {
      const parsed = JSON.parse(content);
      state = convertFromRaw(parsed);
    } catch(e) {
      const blocksFromHTML = convertFromHTML(nlToBr(content));
      state = ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap);
    }
    return EditorState.createWithContent(state, decorator);
  } else {
    return EditorState.createEmpty();
  }
}


function Note (props) {
  const classes = useStyles();
  const [ title, setTitle ] = useState(props.note.title);
  const { hide, note, saveNote, saveStats, newNote, config, stats } = props;
  const [ content, setContent ] = useState('');
  const [ editorState, setEditorState ] = useState(getContent(note, decorator));
  const [ styleChange, setStyleChange ] = useState({type: null, style: null, counter: null});
  prevState = { title: note.title, content: note.content };

  useEffect(() => {
    if (!stats.type) {
      stats.startTime('NOTES');
    }

    return () => {
      if (stats.getType() === 'NOTES') {
        const secs = stats.stopTime();
        saveStats('NOTES', secs);
      }
    }
    // eslint-disable-next-line
  }, []);

  const handleClose = () => {
    saveText();
    hide();
  };

  const saveText = () => {
    let strContent;
    const title2 = title || defaultTitle;
    if (config.simpleNotes) {
      strContent = content;
      // is empty note
      if(!title.trim() && !content.trim()) return; 
    } else {
      const contentRaw = convertToRaw(editorState.getCurrentContent());
      // is empty note
      if(!contentRaw.blocks[0].text.trim() && !title.trim()) return; 
      strContent = JSON.stringify(contentRaw);
    }
    // did not change?
    if(title === prevState.title && strContent === prevState.content) return; 
    prevState = { title, content: strContent };
    if(note.id) {
      saveNote({ id: note.id, title: title2, content: strContent });
    } else {
      newNote({ title: title2, content: strContent });
    }
  }

  const titleChange = (ev) => {
    const title = ev.target.value.substr(0, maxTitleSize);
    setTitle(title);
  }

  return (
    <Modal open={note.open} onClose={handleClose} className={classes.wrapper}>
      <div className={classes.paper}>
        <div className={classes.header} onClick={ev => ev.stopPropagation()}>
          <TitleBar handleClose={handleClose} title={title} titleChange={titleChange}/>
          {!config.simpleNotes && <div className={classes.toolbar}>
            <DraftToolbar setStyleChange={setStyleChange}/>
          </div>}
        </div>
        {config.simpleNotes && <SimpleEditor
          note={note}
          content={content}
          setContent={setContent}
          action={stats.action}
        />}
        {!config.simpleNotes && <DraftEditor 
          note={note}
          editorState={editorState}
          setEditorState={setEditorState}
          styleChange={styleChange}
          action={stats.action}
        />}
      </div>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  return { 
    config: state.config.main,
    stats: state.stats,
  }
}

export default compose(
  connect(mapStateToProps, { saveNote, newNote, saveStats }),
)(Note);
